import { tv } from 'tailwind-variants';

const base = tv({
  variants: {
    disabled: {
      true: 'text-content-disabled-light',
    },
    italic: {
      true: 'italic',
    },
    weight: {
      medium: 'font-medium',
      regular: 'font-normal',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    tracking: {
      tight: 'tracking-[-2%]',
      medium: 'tracking-[-1%]',
      normal: 'tracking-normal',
    },
  },
  defaultVariants: {
    disabled: false,
    italic: false,
    weight: 'regular',
    tracking: 'tight',
  },
});

export { base };
